<template>
  <div>
    <div class="input-group img-group">
      <div class="text-center dropzone logo">
        <input
          class="upload-file img-file-m"
          type="file"
          ref="file"
          accept="image/*"
          @change="handleFileUpload()"
        />
        <input class="upload-file img-file-m" name="logo0" style="z-index: 0" />
        <div class="addImage" v-if="!showImageUrl" style="width: 100%;padding-top: 25px;color: #fff;">
          <a class="addImageIcon btn btn-primary btn-circle">
            <i class="el-icon-upload2"></i>
          </a>
          <p class="text-primary m-t-sm font14 suggestFont">
            <slot name="sizeHint"></slot>
          </p>
        </div>
        <div class="editImage" v-if="showImageUrl">
          <div class="mask-bg"></div>
          <img :src="$store.state.userInfo.config.imageUrl + showImageUrl" />
          <div class="icon-center">
            <span class="edit-icon">
              <i class="el-icon-edit"></i>
              <i class="el-icon-delete pointer" v-if="clear" @click="clearEvent"></i>
            </span>
            <p class=" font14 font-white editFont">{{$props.modifyLabel}}</p>
            <p class="text-primary font-white m-t-sm font14 suggestFont">
              <slot name="sizeHint"></slot>
            </p>
          </div>
        </div>
      </div>
    </div>
    <slot name="sizeError" v-if="haveSizeError">{{$t("message.Image size error") }}</slot>
    <slot name="dimensionError" v-if="haveDimensionError">{{$t("message.Dimension Error") }}</slot>
    <slot name="UploadError" v-if="haveUploadError">Upload Failed!</slot>
  </div>
</template>
<script>
/**
 * props: {
    fileUploadUrl: String,
    value: String,
    modifyLabel: { type: String, default: "Modify" },
    sizeHints: { type: String, default: "" },
    filewidth: { type: Number, default: 0 },
    fileheight: { type: Number, default: 0 },
    limit: { type: Number, default: 0 }
  },
 */
import axios from "axios";
import store from "../../store";
export default {
  name: "file-upload",
  components: {},
  data() {
    return {
      //showImageUrl: ""
      haveSizeError: false,
      haveDimensionError: false,
      haveUploadError: false
    };
  },
  props: {
    fileUploadUrl: String,
    value: String,
    modifyLabel: { type: String, default: "Modify" },
    sizeHints: { type: String, default: "" },
    filewidth: { type: Number, default: 0 },
    fileheight: { type: Number, default: 0 },
    limit: { type: Number, default: 0 },
    type:String,
    accessToken:String,
    callback:null,
    item:{},
    index:null,
    clear:false,
  },
  computed: {
    showImageUrl() {
      return this.$props.value;
    },
    showSizeHint() {
      if (this.$props.sizeHint) {
        return this.$props.sizeHints;
      }
      return `${this.$props.filewidth} x ${this.$props.fileheight}, Max ${this.$props.limit} MB.`;
    }
  },
  methods: {
    _checkFilesize(file) {
      let size = file.size;

      if (size <= this.$props.limit * 1024 * 1024) {
        return true;
      }
      return false;
    },
    async _checkImagesize(file) {
      
      if ((this.$props.filewidth === 0||this.$props.filewidth === "0") && (this.$props.fileheight === 0||this.$props.fileheight === "0")) {
        return true;
      }
      if (file) {
        let imgsize = await new Promise((resolve, reject) => {
          let img = new Image();
          img.onload = () => {
            window.URL.revokeObjectURL(img.src);
            resolve({ height: img.height, width: img.width });
          };
          img.onerror = reject;
          img.src = window.URL.createObjectURL(file);
        });

        let width = imgsize.width,
          height = imgsize.height;

        if (
          width != this.$props.filewidth ||
          height != this.$props.fileheight
        ) {
          return false;
        } else {
          //fail
          return true;
        }
      }

      return false;
    },
    async getImageSize(file){
      if (file) {
        let imgsize = await new Promise((resolve, reject) => {
          let img = new Image();
          img.onload = () => {
            window.URL.revokeObjectURL(img.src);
            resolve({ height: img.height, width: img.width });
          };
          img.onerror = reject;
          img.src = window.URL.createObjectURL(file);
        });

        let width = imgsize.width,
          height = imgsize.height;
        return [width,height];
      }

      return false;
    },
    async handleFileUpload() {
      
      var self = this;
      this.haveSizeError = false;
      this.haveDimensionError = false;
      this.haveUploadError = false;
      this.file = this.$refs.file.files[0];
      var size = await this.getImageSize(this.file)
      if (size[0]>this.$store.state.userInfo.config.mapImagePixel[0]||size[1]>this.$store.state.userInfo.config.mapImagePixel[1]) {
        this.haveDimensionError = true;
        return false;
      }
      if (!(await this._checkImagesize(this.file))) {
        this.haveDimensionError = true;
        return false;
      }
      // if (!this._checkFilesize(this.file)) {
      //   this.haveSizeError = true;
      //   return false;
      // }
        let obj = {};
        if(self.accessToken){
          obj.accessToken = self.accessToken;
        }else{
          obj.accessToken = self.$store.state.userInfo.accessToken;
        }
        obj.tokenType = self.$store.state.userInfo.tokenType;
        obj.lang = "en_US"
        obj.file = this.file;
        obj.type = self.type;


        let formData = new FormData();

        formData.append('type', self.type);
        formData.append('file', this.file);
        formData.append('lang', "en-us")

          var Authorization = obj.tokenType + " " + obj.accessToken;
          delete obj ['tokenType'];
          delete obj ['accessToken'];
        axios
          .post(self.fileUploadUrl, formData,{
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${Authorization}`
                }
            })
          .then(data => {
            if (data.data.code === 0) {
              
              self.$emit("input", data.data.payload.fileName);
              //this.value = data.data.result.url;
              if(self.callback){
                
                self.callback(data.data.payload,self.item,self.index,size[0],size[1]);
              }
            }
            self.$refs.file.value = "";
          })
          .catch(() => {
            self.$refs.file.value = "";
          });
    },
    clearEvent(){
      this.$emit("input", "");
      if(this.callback){
        this.callback({},this.item,this.index,0,0);
      }
    },
  },
  mounted() {},
  created() {}
};
</script>
